/*
    Description: staff overlay class
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/

// import utility
import Utility from "../inc/utility";

// class
class Staff extends Utility{

    // constructor
    constructor({
        // add selectors
        staffClass = "staff__overlay",
        openOverlayClass = "--js-staff-overlay",
        closeClass = "staff__overlay__close",
        profileWrapper = "staff__overlay__block",
        noScrollClass = "--js-noscroll",
        hideClass = "--js-staff-hide",

    } = {}){

        // extend class
        super();

        // staff wrapper
        this.staff = document.querySelector(`.${staffClass}`);
        
        // get staff link DOM element
        this.openButton = document.querySelectorAll(`.${openOverlayClass}`);

        // get close button
        this.closeButton = document.querySelector(`.${closeClass}`);

        // get body tag
        this.body = document.getElementsByTagName("body");

        // set noScroll class
        this.noScroll = noScrollClass;

        // profiles
        this.profiles = profileWrapper,

        // hide 
        this.hide = hideClass;

        // current subscibe link clicked to open overlay 
        this.clickedStaffBttn = null;

        // run evnts
        this.events();

    }

    // run all events
    events(){

        // make sure we have the main staff wrapper
        if(!this.staff) return;

        // enable close event
        if(this.closeButton) this.closeButton.addEventListener("click", this.closeOverlay.bind(this));
        
        // staff link clicked
        this.linkClicked();

        // trap focus
        if(this.staff && (typeof this.trapFocus === "function")) this.trapFocus(this.staff);

        // enter press check on element
        if(this.staff && (typeof this.pressEnterClose === "function")) this.pressEnterClose(this.closeButton, this.closeOverlay.bind(this));        

    }

    //clicked staff link
    linkClicked(){

        // make sure we have links
        if(!this.openButton) return;

        // LOOP: run thru all links on current page
        for(const link of this.openButton){
            
            // add events
            link.addEventListener("click", this.linkEvent.bind(this));
            link.addEventListener("keydown", this.enterOpen.bind(this));
            
        }

    }

    // link click event
    linkEvent(e){

        // prevent default action
        e.preventDefault();

        // update currently clicked staff bttn
        this.clickedStaffBttn = e.target;

        // display staff
        this.displayProperStaff(e);

        // process form
        this.openOverlay();

    }

    // display proper staff member in overlay
    displayProperStaff(e){

        // get target
        const target = e.target,

        // get data
        data = target.dataset.num,

        // select porfiles
        profiles = this.staff.querySelectorAll(`.${this.profiles}`);

        // init i
        let i = 0;

        // LOOP:
        for(i; i < profiles.length; i++){

            // get profile
            const profile = profiles[i],

            // get profile num
            profileNum = profile.dataset.num,

            //  get class list
            getClass = profile.classList;

            // remove existing show
            getClass.add(this.hide)

            // show specific profile
            if(profileNum === data) getClass.remove(this.hide); 

        }

    }

    // open overlay
    openOverlay(){
            
        // remove hide class
        if(this.staff) this.staff.classList.remove(this.hide);
    
        // update attributes
        if(this.staff) this.staff.setAttribute("aria-hidden", false);
        if(this.staff) this.staff.setAttribute("tabindex", 0);

        // focus on close button
        if(this.closeButton) this.closeButton.focus();

        // add no scroll to body
        if(this.body && this.body[0]) this.body[0].classList.add(this.noScroll);

    }

    // display search when user hits enter
    enterOpen(e){

        // check for bttn
        if(!e) return;

        // get current key
        const thisKey = e.key.toLowerCase() || e.keyCode,

        // get active element
        active = document.activeElement;

        // check if focus is on search icon and user hits enter 
        if((active == e.target) && (thisKey == "enter" || thisKey == 13)){
            
            // set clicked bttn
            this.clickedStaffBttn = e.target;

            // open overlay
            this.openOverlay(e);

        }

    }

    // close overlay 
    closeOverlay(e){

        // end case
        if(!this.closeButton) return;

        // prevent default behavior
        e.preventDefault();

        // add hide class
        if(this.staff) this.staff.classList.add(this.hide);

        // update attributes
        if(this.staff) this.staff.setAttribute("aria-hidden", true);
        if(this.staff) this.staff.setAttribute("tabindex", -1);

        // remove no scroll from body tag
        if(this.body && this.body[0]) this.body[0].classList.remove(this.noScroll);

        // focus link to clicked staff link
        if(this.clickedStaffBttn != null) this.clickedStaffBttn.focus();

    }

}

// export module
export default Staff;